/* The figure's shaders, generated from the design canvas "Delt lydklipp"
 * (Salmon.dc.html), which redraws the phoniq-mascot cables.gl patch in one
 * fragment shader. Edit there and regenerate rather than by hand. */
export const VERT = `#version 300 es
in vec2 p; out vec2 vUv;
void main(){ vUv = p; gl_Position = vec4(p, 0., 1.); }`

export const FRAG = `#version 300 es
precision highp float;
in vec2 vUv; out vec4 o;
uniform float uT, uAspect, uYaw, uPitch, uBlink, uSq, uBreath, uMood, uPx;
// The sound, already enveloped in JS: level 0-1, three bands 0-1, and a
// transient kick that decays in ~0.2 s.
uniform float uLevel, uLow, uMid, uHigh, uKick;

mat3 rotY(float a){ float c = cos(a), s = sin(a); return mat3(c,0.,-s, 0.,1.,0., s,0.,c); }
mat3 rotX(float a){ float c = cos(a), s = sin(a); return mat3(1.,0.,0., 0.,c,s, 0.,-s,c); }

// GradientTexture murks73r9, with its smoothstep.
vec3 ramp(float u){
  vec3 c = vec3(1., .87, .46);
  c = mix(c, vec3(.863, .910, .765), smoothstep(.123, .404, u));
  c = mix(c, vec3(.561, .847, .732), smoothstep(.404, .707, u));
  return mix(c, vec3(.676, .913, .895), smoothstep(.707, 1., u));
}

// The two opposed VertexWobbles, for a point on the unit sphere (object space).
float wobble(vec3 q, float t){
  // Lows make the jelly bigger, mids make it quicker, highs make it finer.
  float f = sin(5.32 * (1. + .6 * uHigh) * q.x * q.z * 2. + t * (2. + 4. * uMid));
  float top = clamp(1. - length(q - vec3(0., 1.3, 0.)) / 2.82, 0., 1.);
  float bot = clamp(1. - length(q - vec3(0., -1.3, 0.)) / 2.82, 0., 1.);
  return .13 * (.8 + .6 * uLow) * f * (top - bot);
}

vec2 local(vec3 no, vec3 E, out float k){
  vec3 T = normalize(cross(vec3(0.,1.,0.), E));
  vec3 B = cross(E, T);
  k = dot(no, E);
  return vec2(dot(no, T), dot(no, B)) / max(k, .05);
}

// A soft-edged fill; soft widens the edge (depth blur at the far side).
float fill(float e, float soft){ float a = fwidth(e) + soft; return 1. - smoothstep(1. - a, 1. + a, e); }

float hash(vec2 p){ return fract(sin(dot(p, vec2(12.9898, 78.233))) * 43758.5453); }

void main(){
  vec2 uv = vUv; uv.x *= uAspect;
  // Swells with the level and jumps on a transient.
  float R = .736 * uBreath * (1. + .08 * uLevel + .07 * uKick);
  float loud = smoothstep(.7, .95, uLevel);
  vec3 hc = mix(vec3(.85, .99, .91), vec3(.95, .63, .59), loud);
  uv.y = (uv.y + R) / uSq - R;
  uv.x *= sqrt(uSq);

  float spin = uT * .1745;                    // 10 degrees a second, as the patch's timers
  mat3 S = rotY(spin) * rotX(spin * .8);      // the body turning, under the face

  // The silhouette: where the wobbled sphere's edge is, in this direction.
  float ang = atan(uv.y, uv.x);
  vec3 rim = transpose(S) * vec3(cos(ang), sin(ang), 0.);
  float rr = R * (1. + wobble(rim, uT));
  float d = length(uv) / rr;

  // Soft edge with a slight colour fringe, like the patch's blur and aberration.
  float soft = uPx / rr * 1.6 + .012;
  vec3 mask = vec3(1. - smoothstep(1. - soft, 1. + soft, d * 1.006),
                   1. - smoothstep(1. - soft, 1. + soft, d),
                   1. - smoothstep(1. - soft, 1. + soft, d * .994));
  float body = mask.g;
  float outR = max(d - 1., 0.);
  float halo = exp(-outR * (10. - 6. * uLevel)) * (.3 + .45 * uLevel) * (1. - body);
  // Sound rings, travelling outward, as strong as the level.
  float wv = fract(outR * 4. - uT * 2.4);
  float ring = smoothstep(0., .08, wv) * smoothstep(.24, .08, wv) * exp(-outR * 3.5)
             * (.15 + .85 * uKick) * uLevel * .7 * (1. - body);
  // The face: flat vector shapes on TOP of the body, as in the drawing -- its
  // own layer, composited last, so a wobbling silhouette can never clip an
  // eye or make it look as if it were sliding. It follows the gaze, blinks,
  // breathes and squashes with the body, and nothing else moves it.
  vec3 ink = vec3(.18, .149, .278);
  vec3 eyeRim = vec3(.525, .890, .788);
  float s = R / 1.15 / .93;
  vec2 look = vec2((uYaw - .35) * .55, -uPitch * .45) * R;
  vec2 c0 = vec2(.05, -.05) * s + look;                          // the drawing's body centre
  vec2 eye = vec2(.1125, .1625 * uBlink) * s * (1. + .28 * loud);   // eyes widen at the loud part
  float e1 = length((uv - (c0 + vec2(.1125, .15) * s)) / eye);
  float e2 = length((uv - (c0 + vec2(.525, .15) * s)) / eye);
  float pupil = max(fill(e1, 0.), fill(e2, 0.));
  float rimA = max(fill(e1 / 1.06, 0.) - fill(e1, 0.), fill(e2 / 1.06, 0.) - fill(e2, 0.));
  // Mouth: the small oval at rest, a round O for wow, a slight smile when pleased.
  // The mouth sings along with the mids and opens to an O when it is loud.
  float open = uMood > 1.5 ? 1. : clamp(uMid * uLevel * 1.8 + loud, 0., 1.);
  vec2 mc = c0 + vec2(.325, -.09 - .015 * open) * s;
  float mouthA;
  if (uMood > .5 && uMood < 1.5) {
    vec2 m = (uv - mc) / (vec2(.085, .085) * s);
    float y = .55 * m.x * m.x - .2;
    float aa = fwidth(m.y);
    mouthA = (1. - smoothstep(.17 - aa, .17 + aa, abs(m.y - y))) * (1. - smoothstep(.85, 1., abs(m.x)));
  } else {
    vec2 mouth = mix(vec2(.0525, .03), vec2(.0625, .081), open) * s;
    mouthA = fill(length((uv - mc) / mouth), 0.);
  }
  float faceA = max(max(pupil, rimA), mouthA);
  vec3 faceCol = rimA > max(pupil, mouthA) ? eyeRim : ink;

  // Whatever glows outside the body fades to nothing well inside the canvas,
  // or a loud moment draws the canvas's own edge as a box.
  vec2 ev = abs(vUv);
  float edgeFade = (1. - smoothstep(.72, .97, ev.x)) * (1. - smoothstep(.72, .97, ev.y));
  float glow = min(1., halo + ring) * edgeFade;
  if (max(body, mask.b) < .002 && faceA < .002) { o = vec4(hc * glow, glow); return; }
  if (max(body, mask.b) < .002) {
    vec3 pm = mix(hc * glow, faceCol, faceA);
    o = vec4(pm, max(glow, faceA)); return;
  }

  float dd = min(d, .999);
  vec3 n = normalize(vec3(uv / rr, sqrt(max(0., 1. - dd*dd))));
  vec3 qs = transpose(S) * n;
  // The wobble tilts the surface a little too, so the light slides over it.
  float w0 = wobble(qs, uT);
  n = normalize(n + vec3(.35 * w0 * qs.z, -.25 * w0 * qs.x, 0.));

  // Texture: projected on XY in the turning body's space.
  vec3 qt = transpose(S) * n;
  float u = .5 + qt.x * .46 + .08 * sin(uT * .3);
  vec3 col = ramp(clamp(u, 0., 1.));

  // Phong, as the patch sets it.
  vec3 L = normalize(vec3(2.58, 4.86, 7.68));
  vec3 H = normalize(L + vec3(0., 0., 1.));
  float diff = max(dot(n, L), 0.);
  col *= .74 + .30 * diff;
  col += vec3(1.) * pow(max(dot(n, H), 0.), 4.51) * .537 * .32;
  float edgeF = 1. - max(n.z, 0.);
  col += vec3(.204, .947, 1.) * pow(edgeF, 9.61 * .35) * (.55 + .9 * uHigh);   // cyan Fresnel, shimmers with highs
  col += mix(vec3(1., .875, .145), vec3(.95, .55, .5), loud) * pow(edgeF, 6.97 * .35) * (.30 + .5 * loud);   // warm glow, coral when loud
  col = min(col, vec3(1.));

  // Grain, as the patch's dither.
  col += (hash(vUv * 517. + uT) - .5) * (.018 + .05 * uHigh);   // sparkle with the highs

  vec3 premul = col * mask + hc * glow;
  premul = mix(premul, faceCol, faceA);
  o = vec4(premul, max(max(body, glow), faceA));
}`
